import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/pages/EntitySelected.js";
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { Grid, Paper, AppBar, Tabs, Tab, Typography, Button } from '@material-ui/core';
import Chip from "@material-ui/core/Chip";
import { EntityInfo, SimpleSnackbar } from '../common';
import queryString from 'query-string';
import Footer from '../navigation/Footer';
import Util from '../../util/Util';
import { fillInEntityInfo } from "../../util/APIUtil";
import ImageTable from '../images/ImageTable';
import TpicPage from './TpicPage';
import { IMAGETABLE_DESCRIPTIONS, BASE_URIS, LOCAL_STORAGE_ITEM_NAMES, DISPLAY_IMAGES, Q_STRING, TPIS_CAPABILITIES as CAPS } from "../domain/constants";
import { changeSearchValue, changeSearchValues, retrieveFromQueryString, setUpTabInfoFromQueryString } from "../../util/QueryStringUtil";
import { stringToList } from "../../util/StringUtil";
import { UPDATE_PROGRAM } from "../Routes";

// TODO: Undupe this code
const styles = theme => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '80vw',
    minWidth: '80vw'
  },
  tabs: {
    backgroundColor: theme.palette.background.paper,
    minWidth: '80%',
    maxWidth: '80%',
    margin: 0
  }
});
class EntitySelected extends TpicPage {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", (event, value) => {
      this.setState({
        value
      });
      let params = {};
      params[Q_STRING.TAB] = value;
      params[Q_STRING.PAGE] = 1;
      changeSearchValues(params, this.props);
    });
    const querystringValues = queryString.parse(this.props.location.search);
    const tab = EntitySelected.determineTabValueFromQueryString(querystringValues);
    let allAdiIds = [];
    if (props.location != null && props.location.state != null) {
      allAdiIds = props.location.state.allAdiIds;
    }
    let encodedTitle = retrieveFromQueryString(Q_STRING.TITLE, querystringValues);
    let decodedTitle = encodedTitle;
    try {
      decodedTitle = decodeURIComponent(encodedTitle);
    } catch (err) {
      if (err.name === "URIError") {
        console.warn("".concat(encodedTitle, " is either already decoded or is malformed"));
      }
    }
    this.state = {
      merlinId: props.merlinId != null ? props.merlinId : retrieveFromQueryString(Q_STRING.MERLIN_ID, querystringValues),
      title: props.title != null ? props.title : decodedTitle,
      adiId: props.adiId != null ? props.adiId : retrieveFromQueryString(Q_STRING.ADI_ID, querystringValues),
      subtitle: null,
      allAdiIds: allAdiIds,
      value: tab !== -1 ? tab : 0,
      // tab value
      selectedImages: DISPLAY_IMAGES.new,
      partnerOwnerId: localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.partnerOwnerId)
    };
    if (tab === -1) {
      changeSearchValue(Q_STRING.TAB, 0, props);
    }
    this.snackbar = null;
    this.setSnackbarRef = element => {
      this.snackbar = element;
    };
    fillInEntityInfo(this);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const defaultValue = 0;
    const querystringValues = queryString.parse(this.props.location.search);
    const tabValueFromQString = EntitySelected.determineTabValueFromQueryString(querystringValues);
    setUpTabInfoFromQueryString(this, prevState, defaultValue, querystringValues, tabValueFromQString);
    if (this.state.adiId !== prevState.adiId || this.state.merlinId !== prevState.merlinId) {
      fillInEntityInfo(this);
    }
  }
  componentDidMount() {
    if (this.state.value === 0) {
      this.determineShouldDefaultToLegacyImages();
    }
  }
  makePath() {
    let path = UPDATE_PROGRAM;
    let firstIsSet = false;
    if (this.state.merlinId != null) {
      path += "?".concat(Q_STRING.ENTITY_ID, "=").concat(this.state.merlinId);
      firstIsSet = true;
    } else if (this.state.entityId != null) {
      path += "?".concat(Q_STRING.ENTITY_ID, "=").concat(this.state.entityId);
      firstIsSet = true;
    } else if (this.state.adiId != null) {
      path += "?".concat(Q_STRING.ENTITY_ID, "=").concat(this.state.adiId);
      firstIsSet = true;
    }
    if (this.state.title) {
      path += (firstIsSet ? '&' : '?') + "".concat(Q_STRING.TITLE, "=").concat(this.state.title);
    }
    return path;
  }
  render() {
    const classes = this.props.classes;
    const _this$state = this.state,
      value = _this$state.value,
      selectedImages = _this$state.selectedImages,
      partnerOwnerId = _this$state.partnerOwnerId;
    const caps = stringToList(localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.capabilities));
    const key = "".concat(this.state.adiId, "-").concat(this.state.merlinId, "-").concat(this.state.title, "-").concat(this.state.type);
    return /*#__PURE__*/React.createElement("div", {
      id: "grid-container",
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 145,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(SimpleSnackbar, {
      ref: this.setSnackbarRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 146,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      alignContent: "center",
      direction: "column",
      spacing: 1,
      justify: "space-around",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 147,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 148,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(EntityInfo, {
      key: key,
      merlinId: this.state.merlinId,
      title: this.state.title,
      subtitle: this.state.subtitle,
      adiId: EntitySelected.determineAdiDisplay(this.state.adiId, this.state.allAdiIds),
      type: this.state.type,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 149,
        columnNumber: 25
      }
    })), partnerOwnerId != null && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 158,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: () => {
        let path = this.makePath();
        this.props.history.push(path);
      },
      elevation: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 159,
        columnNumber: 25
      }
    }, "Update Program Info")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "column",
      alignContent: "center",
      justify: "center",
      spacing: 5,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 165,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 166,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Paper, {
      elevation: 0,
      style: {
        overflow: 'hidden'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 167,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(AppBar, {
      position: "sticky",
      style: {
        overflow: 'hidden'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 168,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Tabs, {
      value: value,
      variant: "scrollable",
      onChange: this.handleChange,
      style: {
        overflow: 'hidden'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 170,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      label: "All",
      value: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 172,
        columnNumber: 41
      }
    }), caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT]) && /*#__PURE__*/React.createElement(Tab, {
      label: "Audit Pending",
      value: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174,
        columnNumber: 41
      }
    }), caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.READ]) && /*#__PURE__*/React.createElement(Tab, {
      label: "Accepted",
      value: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 177,
        columnNumber: 41
      }
    }), caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.READ]) && /*#__PURE__*/React.createElement(Tab, {
      label: "Rejected",
      value: 3,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 180,
        columnNumber: 41
      }
    }), caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(Tab, {
      label: "Publish Pending",
      value: 4,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 183,
        columnNumber: 41
      }
    }), caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(Tab, {
      label: "Publish Failed",
      value: 6,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 186,
        columnNumber: 41
      }
    }), /*#__PURE__*/React.createElement(Tab, {
      label: "Published",
      value: 5,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 188,
        columnNumber: 41
      }
    }), /*#__PURE__*/React.createElement(Tab, {
      label: "Existing",
      value: 7,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 189,
        columnNumber: 41
      }
    }))), value === 0 && selectedImages === DISPLAY_IMAGES.new && [this.getNewLegacyChips(), /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      description: IMAGETABLE_DESCRIPTIONS.all,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 196,
        columnNumber: 37
      }
    })], value === 0 && selectedImages === DISPLAY_IMAGES.legacy && [this.getNewLegacyChips(), /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listLegacyImages,
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      description: IMAGETABLE_DESCRIPTIONS.legacy,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 207,
        columnNumber: 37
      }
    })], value === 1 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT]) && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      description: IMAGETABLE_DESCRIPTIONS.auditPending,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 217,
        columnNumber: 33
      }
    }), value === 2 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.READ]) && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      description: IMAGETABLE_DESCRIPTIONS.accepted,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 227,
        columnNumber: 33
      }
    }), value === 3 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.READ]) && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      description: IMAGETABLE_DESCRIPTIONS.rejected,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 237,
        columnNumber: 33
      }
    }), value === 4 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      description: IMAGETABLE_DESCRIPTIONS.publishPending,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 247,
        columnNumber: 33
      }
    }), value === 6 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      description: IMAGETABLE_DESCRIPTIONS.publishFailed,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 256,
        columnNumber: 33
      }
    }), value === 5 && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listImages,
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      description: IMAGETABLE_DESCRIPTIONS.published,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 266,
        columnNumber: 33
      }
    }), value === 7 && /*#__PURE__*/React.createElement(ImageTable, {
      baseUri: BASE_URIS.listExistingImages,
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      description: IMAGETABLE_DESCRIPTIONS.existing,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 276,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(Footer, {
      merlinId: this.state.merlinId,
      title: this.state.title,
      adiId: this.state.adiId,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 284,
        columnNumber: 33
      }
    }))))));
  }
  setSelectedImages(qualifier) {
    this.setState({
      selectedImages: qualifier
    });
  }
  static determineAdiDisplay(providedId, allIds) {
    if (allIds != null && allIds.length > 0) {
      let display = '';
      let firstSet = false;
      let appended = [];
      allIds.map(id => {
        if (!appended.includes(id)) {
          if (firstSet === true) {
            display += ', ';
          }
          display += id;
          appended.push(id);
          firstSet = true;
        }
      });
      return display;
    } else {
      if (providedId != null && providedId !== '') {
        return providedId;
      } else {
        return 'n/a';
      }
    }
  }

  /**
   * Users can pass any value in the t= param so we have to check if they're
   * allowed to view the contents of that tab anyway (it won't even show up for them
   * if their capabilities don't allow it anyway), or if it's even a real tab
   * @returns {number}
   */
  static determineTabValueFromQueryString(querystringValues) {
    try {
      let tab = retrieveFromQueryString(Q_STRING.TAB, querystringValues);
      let tabInt = -1;
      if (tab != null && tab !== '') {
        tabInt = parseInt(tab, 10);
      } else {
        return 0;
      }
      if (tabInt >= 0 && tabInt <= 6) {
        let caps = stringToList(localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.capabilities));
        if (caps == null) {
          return -1;
        }
        if (caps.includes(CAPS.AUDIT)) {
          if (tabInt !== -1 && [0, 1, 2, 3, 5].includes(tabInt)) {
            return tabInt;
          }
        } else if (caps.includes(CAPS.PUBLISH)) {
          if (tabInt !== -1 && [0, 4, 5, 6].includes(tabInt)) {
            return tabInt;
          }
        } else if (caps.includes(CAPS.READ)) {
          if (tabInt !== -1 && [0, 2, 3, 5].includes(tabInt)) {
            return tabInt;
          }
        } else if (caps.includes(CAPS.ADMIN)) {
          // Admin can see any tab
          if (tabInt !== -1) {
            return tabInt;
          }
        }
      }
    } catch (e) {
      Util.log('EntitySelected.determineTabValueFromQueryString', true, e.message, true);
    }
    return -1;
  }

  /**
   * Calls TPIS for listImages for the current page. If there are no results in the response, it defaults the page to listLegacyImages
   */
  determineShouldDefaultToLegacyImages() {
    const state = this.state;
    const snackbar = this.snackbar;
    const providerAndEntityId = ImageTable.determineProviderAndEntityId({
      merlinId: state.merlinId,
      adiId: state.adiId
    });
    if (providerAndEntityId.success === true) {
      const uri = ImageTable.makeUri(providerAndEntityId.provider, providerAndEntityId.entityId, '', {
        baseUri: BASE_URIS.listImages,
        page: 0,
        pageSize: 10
      });
      if (uri == null) {
        Util.openSnackbar('Unable to look up assets', snackbar);
      }
      Util.fetchWithRedirect(uri, 'GET', this.props).then(resp => {
        if (resp.totalElements == null || resp.totalElements === 0) {
          // Now we have to try again, except this time we're looking for legacy images
          const uri = ImageTable.makeUri(providerAndEntityId.provider, providerAndEntityId.entityId, '', {
            baseUri: BASE_URIS.listLegacyImages,
            page: 0,
            pageSize: 10
          });
          if (uri == null) {
            Util.openSnackbar('Unable to look up assets', snackbar);
          }
          Util.fetchWithRedirect(uri, 'GET', this.props).then(resp => {
            if (resp.totalElements == null || resp.totalElements === 0) {
              // Now, there are no legacy images either
              Util.openSnackbar('There are no images uploaded to this entity through TPIS or the legacy third party image delivery service.', snackbar);
            } else {
              // There are legacy images, default to that tab
              Util.openSnackbar('There were no images uploaded through TPIS. Defaulting to Legacy images', snackbar);
              this.state.selectedImages = DISPLAY_IMAGES.legacy;
              this.forceUpdate();
            }
          });
        }
      }).catch(e => {
        Util.log('EntitySelected.determineShouldDefaultToLegacyImages', true, e, false);
      });
    }
  }
  getNewLegacyChips() {
    let selectedImages = this.state.selectedImages;
    return /*#__PURE__*/React.createElement(Grid, {
      style: {
        marginTop: '5px'
      },
      container: true,
      spacing: 1,
      justify: 'center',
      alignItems: 'center',
      alignContent: 'center',
      direction: 'row',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 435,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 437,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      align: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 438,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Chip, {
      label: 'Actionable Images',
      clickable: true,
      onClick: () => this.setSelectedImages(DISPLAY_IMAGES.new),
      variant: selectedImages === DISPLAY_IMAGES.new ? "default" : "outlined",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 439,
        columnNumber: 25
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 445,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      align: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 446,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Chip, {
      label: 'Legacy Images',
      clickable: true,
      onClick: () => this.setSelectedImages(DISPLAY_IMAGES.legacy),
      variant: selectedImages === DISPLAY_IMAGES.legacy ? "default" : "outlined",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 447,
        columnNumber: 25
      }
    }))));
  }
}
export default withStyles(styles)(withRouter(EntitySelected));